import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface IPageLayoutSkeletonProps {
  actionBarSkeleton?: React.ReactNode;
}

export const PageLayoutSkeleton: React.FC<
  React.PropsWithChildren<IPageLayoutSkeletonProps>
> = ({ children, actionBarSkeleton }) => (
  <>
    <div className="bg-background-grey sticky inset-0 z-20 flex justify-between border-b border-grey-light px-4 py-5 md:-mx-8 md:px-8 lg:border-0 lg:py-10">
      <Skeleton variant="rounded" className="h-6 w-[177px] lg:hidden" />
      <Skeleton className="hidden w-[150px] text-3xl lg:inline-flex" />
      <div className="hidden gap-4 lg:flex">
        <Skeleton variant="circular" className="h-10 w-10" />
        <div className={"flex gap-3 text-sm"}>
          <Skeleton variant="circular" className="h-10 w-10" />
          <div className="flex flex-col gap-2">
            <div className="flex flex-row gap-2">
              <Skeleton className="text-xs" />
              <Skeleton className="text-xs" />
            </div>
            <Skeleton className="w-[100px] text-xs" />
          </div>
        </div>
      </div>
      <Skeleton variant="rectangular" className="h-6 w-6 lg:hidden" />
    </div>
    <div className="bg-background-grey sticky inset-0 inset-y-[65px] z-20 mb-[1px] flex justify-between px-4 pb-5 pt-8 md:-mx-8 md:px-8 md:pb-4 md:pt-0 lg:inset-y-[120px]">
      <div className="inline-flex items-center lg:hidden">
        <Skeleton className="w-[130px] text-2xl lg:hidden" />
      </div>
      {actionBarSkeleton}
    </div>
    {children}
  </>
);
